module.exports = {
  BASE_URL: 'https://api.borigenbetzel.com.ar/api'
  //BASE_URL: 'http://10.0.0.98:3000/api'
  //BASE_URL: 'http://localhost:3000/api'
}